module.exports = __webpack_public_path__ + "static/media/016.a3c3a8d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/016.jpg
// module id = 363
// module chunks = 0